import React from 'react';
import { useAuth } from '../../../context/AuthContext';
import AdminAnalyticsPage from './AdminAnalyticsPage';
import BusinessAnalyticsPage from './BusinessAnalyticsPage';

/**
 * Analytics router component that renders the appropriate analytics page 
 * based on the user's role.
 * 
 * - For admin users: Renders the AdminAnalyticsPage with global metrics across all businesses
 * - For business managers: Renders the BusinessAnalyticsPage with metrics specific to their business
 */
const AnalyticsPage: React.FC = () => {
  const { currentUser } = useAuth();
  const isAdmin = currentUser?.role === 'admin';
  
  // Render the appropriate analytics page based on user role
  return isAdmin ? <AdminAnalyticsPage /> : <BusinessAnalyticsPage />;
};

export default AnalyticsPage;